import api from './api';

export const cohortsService = {
  async getCohorts() {
    const response = await api.get('/api/cohorts/');
    return response.data;
  },

  async createCohort(data) {
    const response = await api.post('/api/cohorts/', data);
    return response.data;
  },

  async deleteCohort(id) {
    const response = await api.delete(`/api/cohorts/${id}/`);
    return response.data;
  },

  async getCohortContent(cohortId) {
    const response = await api.get(`/api/cohorts/${cohortId}/content/`);
    return response.data;
  },

  async addContentToCohort(cohortId, formData) {
    const response = await api.post(`/api/cohorts/${cohortId}/content/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  async searchTextbooks(query) {
    const response = await api.get(`/api/cohorts/search/textbooks?query=${encodeURIComponent(query)}`);
    return response.data;
  },

  async suggestImprovements(cohortId) {
    const response = await api.post(`/api/cohorts/${cohortId}/suggest-improvements/`);
    return response.data;
  },

  // Content editing methods
  async updateContent(cohortId, contentId, formData) {
    const response = await api.put(`/api/cohorts/${cohortId}/content/${contentId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },

  async getContentItem(cohortId, contentId) {
    const response = await api.get(`/api/cohorts/${cohortId}/content/${contentId}/`);
    return response.data;
  },

  async deleteContentItem(cohortId, contentId) {
    const response = await api.delete(`/api/cohorts/${cohortId}/content/${contentId}/`);
    return response.data;
  },

  // Content viewing methods
  async getContentDetails(cohortId, contentId) {
    const response = await api.get(`/api/cohorts/${cohortId}/content/${contentId}/details/`);
    return response.data;
  },

  async getContentFile(cohortId, contentId) {
    const response = await api.get(`/api/cohorts/${cohortId}/content/${contentId}/file/`, {
      responseType: 'blob'
    });
    return response.data;
  }
};

export const emailService = {
  async getEmails(skip = 0, limit = 50) {
    const response = await api.get(`/api/emails/?skip=${skip}&limit=${limit}`);
    return response.data;
  },

  async generateDraft(emailId, cohortId) {
    const encodedEmailId = encodeURIComponent(emailId);
    const response = await api.post(`/api/emails/${encodedEmailId}/generate-draft/`, {
      cohort_id: cohortId
    });
    return response.data;
  },

  async sendEmail(emailId, editedDraft) {
    const encodedEmailId = encodeURIComponent(emailId);
    const response = await api.post(`/api/emails/${encodedEmailId}/send/`, {
      edited_draft: editedDraft
    });
    return response.data;
  },

  async saveDraft(emailId, editedDraft) {
    const encodedEmailId = encodeURIComponent(emailId);
    const response = await api.post(`/api/emails/${encodedEmailId}/save-draft/`, {
      edited_draft: editedDraft
    });
    return response.data;
  }
};

export const userService = {
  async getUserData() {
    const response = await api.get('/api/user/data/');
    return response.data;
  },

  async updateUserData(userData) {
    const response = await api.put('/api/user/data/', userData);
    return response.data;
  },

  async deleteAccount() {
    const response = await api.delete('/api/user/account/');
    return response.data;
  }
};

export const stripeService = {
  async getPlans() {
    const response = await api.get('/api/stripe/plans/');
    return response.data;
  },

  async createCheckoutSession(priceId) {
    const response = await api.post('/api/stripe/create-checkout-session/', {
      price_id: priceId
    });
    return response.data;
  },

  async createBillingPortalSession() {
    const response = await api.get('/api/stripe/billing-portal/');
    return response.data;
  }
};

// Utility function for error handling (optional - can be used in components)
export const handleApiError = (error) => {
  if (error.response) {
    // Server responded with error status
    console.error('API Error:', error.response.data);
    throw new Error(error.response.data.message || 'An error occurred');
  } else if (error.request) {
    // Request made but no response received
    console.error('Network Error:', error.request);
    throw new Error('Network error. Please check your connection.');
  } else {
    // Something else happened
    console.error('Error:', error.message);
    throw new Error('An unexpected error occurred');
  }
};

export default {
  cohortsService,
  emailService,
  userService,
  stripeService,
  handleApiError
};
